import { useEffect, useState } from "react";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import AfficheProductsService from "../../../Services/Admin/AfficheProductsService";
import { Link } from "react-router-dom";
import "swiper/css/free-mode";
import "./AllArticleMobil.css";
import "swiper/css/autoplay";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import SideBarMobile from "../Sidbare/SideBarMobile";
import axios from "axios";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import ArticlesLoader from "../../../components/ArticlesLoader";

export default function AllArticleMobile() {
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState<ArticleInfo[]>([]);
  const [alldata, setAlldata] = useState<ArticleInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 30;
  const [totalPages, setTotalPages] = useState(1);

  const fetchProducts = (pageNumber: number) => {
    setLoading(true);
    AfficheProductsService()
      .getProductPagination(pageNumber)
      .then((res: any) => {
        setProducts(res.data.data);
        setAlldata(res.data.alldata);
        setTotalPages(res.data.last_page);
        setLoading(false);
      })
      .catch((err: any) => {
        console.error("Error fetching products: ", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const filteredProducts = alldata.filter((pro: ArticleInfo) => {
    const refs = Array.isArray(pro.RefArticle)
      ? pro.RefArticle
      : [pro.RefArticle];

    return (
      pro.Designation?.toLowerCase().includes(search.toLowerCase()) ||
      pro.PrixVenteArticleTTC?.toLowerCase().includes(search.toLowerCase()) ||
      refs.some((ref) => ref?.toLowerCase().includes(search.toLowerCase())) ||
      pro.DesignationAr?.toLowerCase().includes(search.toLowerCase())
    );
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredProducts.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
    const [showPopup, setShowPopup] = useState(false);
    const [Waiting, setWaiting] = useState(false);
    const [Message, setMessage] = useState("");
    const UpdateArticles = async () => {
  // try {
  console.log("test");
    setShowPopup(true);
    // setWaiting(true);


    // Run API call, but don’t wait for it to finish before hiding popup

};

  return (
    <>
             <NewSideBarAdmin/>
      
      <div className="container">
        <div className="search-part position-relative mb-3">
          <i
            className="bi bi-search position-absolute"
            style={{
              top: "20%",
              left: "10px",
              transform: "translateY(-50%)",
              fontSize: "16px",
              color: "#6c757d",
            }}
          ></i>
          <input
            onChange={handleSearch}
            className="form-control ps-5 pe-5"
            type="text"
            placeholder="Recherchez un produit, une référence..."
            aria-label="search input"
          />
          <i
            className="bi bi-sliders position-absolute"
            style={{
              top: "20%",
              right: "10px",
              transform: "translateY(-50%)",
              fontSize: "16px",
              color: "#6c757d",
            }}
          ></i>
          <Link
            to="/articles/categories/add"
            type="button"
            className="w-100 mt-3 btn btn-sm"
          >
            Ajouter un produit
          </Link>
                <i
        style={{
          // display: "flex",
          position:"absolute",
          zIndex: 1,
          marginLeft: "2%",
          marginTop:"4%",
          backgroundColor: "#242424",
          color: "white",
          padding: "1.2% 2.5% 1.2% 2.5%",
          borderRadius: "50%",
          fontSize: "1.1rem",
          cursor:"pointer"
        }}
         onClick={UpdateArticles} 
        className="bi bi-arrow-repeat"
      ></i>
        </div>
                   {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "35px",
              borderRadius: "10px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <p style={{fontFamily:"lato",}}>Etes-vous sûr de vouloir mettre à jour les articles ?</p>
            <div style={{ display: "flex", justifyContent: "space-around", marginTop: "15px" }}>
              <button
                onClick={UpdateArticles}
                disabled={loading}
                style={{
                  background: "#242424",
                  color: "white",
                  border: "none",
                  padding: "8px 15px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                oui
              </button>
              <button
                onClick={() => setShowPopup(false)}
                style={{
                  background: "lightgray",
                  border: "none",
                  padding: "8px 15px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
        {loading ? (
          <ArticlesLoader />
        ) : currentRecords.length > 0 ? (
          <div className="container mobile-article-card">
            <div className="produit-available">
              <p>Equipement</p>
              <Link to="/articles" className="vrp">
                Voir plus<i className="bi bi-arrow-right-short"></i>
              </Link>
            </div>
            <div
              className="container mobile-article-card"
              style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}
            >
              <Swiper
                freeMode={true}
                grabCursor={true}
                className="myswiper"
                style={{
                  width: "110%",
                  marginTop: "5px",
                  marginBottom: "120px",
                  marginLeft: "-25px",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.8,
                    spaceBetween: 10,
                  },
                  380: {
                    slidesPerView: 1.8,
                    spaceBetween: 15,
                  },
                  500: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                }}
                centeredSlides={false}
                initialSlide={0}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, FreeMode]}
              >

                {currentRecords.map((pro) => (
                  <SwiperSlide
                    key={pro.id}
                    style={{
                      width: "170px",
                      height: "260px",
                      position: "relative",
                    }}
                  >
                    <Link
                      className="product-link"
                      to={`/home/${pro.NomMagasin}/articles/${pro.RefArticle}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div
                        className="u-card"
                        style={{
                          height: "100%",
                          padding: "5px",
                          marginTop: "8px",
                          marginLeft: "10px",
                        }}
                      >
                        <div className="u-off">
                          <span
                            className="off"
                            style={{
                              background: "#EFD33D",
                              color: "black",
                              padding: "2px 5px",
                              borderRadius: "3px",
                              fontSize: "12px",
                              position: "absolute",
                              top: "5px",
                              left: "5px",
                              zIndex: 1,
                            }}
                          >
                            25% off
                          </span>
                        </div>
                        <img
                          src={pro.urlImage}
                          alt={pro.Designation}
                          className="u-card-img"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover",
                            marginBottom: "5px",
                          }}
                        />
                        <div className="u-card-icons">
                          <i className="bi bi-suit-heart u-heart"></i>
                          <i className="bi bi-cart u-card-shopping"></i>
                        </div>
                        <div className="u-km">
                          <p
                            style={{
                              fontSize: "10px",
                              margin: "2px 0",
                              color: "#000000",
                            }}
                          >
                            À 10 Km de chez vous
                          </p>
                        </div>
                        <div className="u-star" style={{ margin: "3px 0" }}>
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className="bi bi-star-fill u-i-star"
                              style={{
                                fontSize: "10px",
                                color: "#FFD700",
                              }}
                            ></i>
                          ))}
                        </div>
                        <div
                          className="u-card-title"
                          style={{
                            width: "100%",
                            height: "64px",
                            fontSize: "12px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              marginBottom: "3px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {pro.Designation}
                            {pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
                          </div>
                          <p
                            className="u-card-ref-ar"
                            style={{
                              fontSize: "12px",
                              margin: "2px 0",
                              color: "#666",
                            }}
                          >
                            Ref : {pro.RefArticle}
                          </p>
                          <div
                            className="u-card-price"
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "#2DA5F3",
                              marginTop: "5px",
                            }}
                          >
                            {pro.PrixNetHT} MAD
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        ) : (
          <div className="no-produit">
            <i className="bi bi-emoji-neutral"></i>
            <br />
            <p>Malheureusement, on n‘a pas ce produit pour l’instant.</p>
            <br />
          </div>
        )}
        <div className="pagination mb-5">
          <button
            style={{ borderRadius: "100%" }}
            className="page-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <i className="bi bi-arrow-left"></i>
          </button>
          <span className="page-info">
            Page {currentPage} of{" "}
            {Math.ceil(filteredProducts.length / recordsPerPage)}
          </span>
          <button
            style={{ borderRadius: "100%" }}
            className="page-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage * recordsPerPage >= filteredProducts.length}
          >
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>

        {loading ? (
          <ArticlesLoader />
        ) : currentRecords.length > 0 ? (
          <div
            className="container mobile-article-card"
            style={{ marginTop: "-60%" }}
          >
            <div className="produit-available">
              <p>Lubrifiants</p>
              <Link to="/articles" className="vrp">
                Voir plus<i className="bi bi-arrow-right-short"></i>
              </Link>
            </div>
            <div
              className="container mobile-article-card"
              style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}
            >
              <Swiper
                freeMode={true}
                grabCursor={true}
                className="myswiper"
                style={{
                  width: "110%",
                  marginTop: "5px",
                  marginBottom: "90px",
                  marginLeft: "-25px",
                  zIndex: -1,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.8,
                    spaceBetween: 10,
                  },
                  380: {
                    slidesPerView: 1.8,
                    spaceBetween: 15,
                  },
                  500: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                }}
                centeredSlides={false}
                initialSlide={0}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, FreeMode]}
              >
                {currentRecords.map((pro) => (
                  <SwiperSlide
                    key={pro.id}
                    style={{
                      width: "170px",
                      height: "260px",
                      position: "relative",
                    }}
                  >
                    <Link
                      className="product-link"
                      to={`/home/${pro.NomMagasin}/articles/${pro.RefArticle}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div
                        className="u-card"
                        style={{
                          height: "100%",
                          padding: "5px",
                          marginTop: "8px",
                          marginLeft: "10px",
                        }}
                      >
                        <div className="u-off">
                          <span
                            className="off"
                            style={{
                              background: "#EFD33D",
                              color: "black",
                              padding: "2px 5px",
                              borderRadius: "3px",
                              fontSize: "12px",
                              position: "absolute",
                              top: "5px",
                              left: "5px",
                              zIndex: 1,
                            }}
                          >
                            25% off
                          </span>
                        </div>
                        <img
                          src={pro.urlImage}
                          alt={pro.Designation}
                          className="u-card-img"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover",
                            marginBottom: "5px",
                          }}
                        />
                        <div className="u-card-icons">
                          <i className="bi bi-suit-heart u-heart"></i>
                          <i className="bi bi-cart u-card-shopping"></i>
                        </div>
                        <div className="u-km">
                          <p
                            style={{
                              fontSize: "10px",
                              margin: "2px 0",
                              color: "#000000",
                            }}
                          >
                            À 10 Km de chez vous
                          </p>
                        </div>
                        <div className="u-star" style={{ margin: "3px 0" }}>
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className="bi bi-star-fill u-i-star"
                              style={{
                                fontSize: "10px",
                                color: "#FFD700",
                              }}
                            ></i>
                          ))}
                        </div>
                        <div
                          className="u-card-title"
                          style={{
                            width: "100%",
                            height: "64px",
                            fontSize: "12px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "bold",
                              marginBottom: "3px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {pro.Designation}
                            {pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
                          </div>
                          <p
                            className="u-card-ref-ar"
                            style={{
                              fontSize: "12px",
                              margin: "2px 0",
                              color: "#666",
                            }}
                          >
                            Ref : {pro.RefArticle}
                          </p>
                          <div
                            className="u-card-price"
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "#2DA5F3",
                              marginTop: "5px",
                            }}
                          >
                            {pro.PrixNetHT} MAD
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        ) : (
          <div className="no-produit">
            <i className="bi bi-emoji-neutral"></i>
            <br />
            <p>Malheureusement, on n‘a pas ce produit pour l’instant.</p>
            <br />
          </div>
        )}
      </div>
    </>
  );
}
